import { getAssetUrlInWorker } from '../getAssetUrl'

export default async ({
  editorSdkProxy,
  logger,
  shouldShowIllustration = true,
  illustration,
  helpId,
  headerText,
  topDescriptionText,
  bottomDescriptionText,
  mainActionText,
  secondaryActionText,
  onMainActionClick,
  onSecondaryActionClick,
  onCloseClick,
}) => {
  let panelResult = null
  try {
    panelResult = await editorSdkProxy.editor.openErrorPanel({
      shouldShowIllustration,
      illustration:
        illustration ||
        (await getAssetUrlInWorker(
          editorSdkProxy,
          'panel-icons/generic_trash.svg',
        )),
      helpId,
      headerText,
      topDescriptionText,
      bottomDescriptionText,
      mainActionText,
      secondaryActionText,
    })
  } catch (error) {
    logger.error(new Error('Failed to open error panel', { cause: error }))
  }

  try {
    const actions = {
      mainActionClicked: onMainActionClick,
      secActionClicked: onSecondaryActionClick,
      closeActionClicked: onCloseClick,
    }

    const action = actions[panelResult]

    if (action) {
      await action()
    }
  } catch (error) {
    logger.error(
      new Error('Failed to execute error panel action', { cause: error }),
    )
  }
}
